export const styles = {
	layout: {
		display: 'flex'
	},
	addEmailSection: {
		padding: '16px'
	},
	addEmailButton: {
		paddingLeft: '16px',
		paddingRight: '16px',
		marginLeft: 'auto',
		textTransform: 'capitalize',
		color: '#fff',
		display: 'flex'
	},
	moveForwardSection: {
		flexGrow: 1,
		padding: '9px',
		display: 'flex'
	},
	iconOffset: {
		marginRight: '8px',
		color: 'primary'
	},
	btnTestEmail: {
		textTransform: 'unset',
		fontSize: '15px',
		'&:disabled svg': {
			fill: 'rgb(0,0,0,0.26)'
		}
	},
	positioning: {
		position: 'absolute',
		bottom: 0,
		left: 0
	}
};
